<template>
<div style="width:100%" class="text-center">
  <v-btn text color="secondary" v-if="value && !uploading" @click="$eventBus.$emit('play_video',value)">
    <v-icon small color="primary" class="mr-2">fa-play</v-icon>
    Congrats
  </v-btn>
  <v-btn text color="secondary" v-if="!value && !uploading" @click="openFileSelect">
    <v-icon small color="primary" class="mr-2">fa-plus</v-icon>
    Congrats
  </v-btn>
  <div class="pt-2" v-if="uploading">
    <v-progress-circular :value="upload_progress" :size="30" :width="1" color="green"> {{ upload_progress }}</v-progress-circular>
  </div>
  <br />
  <v-btn text color="red" v-if="value" @click="$emit('input',null)" small>Clear</v-btn>
  <input type="file" style="display:none" accept="video/*" :id="`videos-file-${random_id}`" @change="handleFileChange" multiple />
</div>
</template>
<script>
import Axios from 'axios'

export default {
  name: "",
  props: ['value'],
  data: () => ({
    random_id: Math.round(Math.random() * 100),
    uploading: false,
    upload_progress: 0
  }),
  methods: {
    openFileSelect() {
      document.querySelector(`#videos-file-${this.random_id}`).click()
    },
    handleFileChange(ev) {
      ev.preventDefault();
      let file = ev.target.files[0];
      this.uploadFile(file)
      ev.target.value = null

    },
    async uploadFile(file) {
      this.uploading = true
      try {
        this.upload_progress = 0
        let upload_url = await this.$api({
          method: "POST",
          url: `/account/upload-url`,
          data: {
            file: {
              name: file.name,
              size: file.size,
              type: file.type
            },
            key: `revision-videos/random-${Math.round(Math.random() * 100)}`
          }
        })
        var upload_options = {
          headers: {
            'Content-Type': file.type,
            'x-amz-acl': 'public-read'
          },
          'Metadata': {
            'Content-Disposition': 'attachment'
          },
          onUploadProgress: function(progressEvent) {
            console.log(progressEvent)
            this.upload_progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }.bind(this)
        };
        await Axios.put(upload_url, file, upload_options)

        this.$emit('input', upload_url.split("?")[0])
      } catch (ex) {
        alert("Upload failed")
      }
      this.uploading = false;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
